uniform float uSize;
uniform float uTime;
attribute float aScale;
attribute vec3 aRandomness;

varying vec3 vColor;

void main()
{
    /**
     * Position
     */
    vec4 modelPosition = modelMatrix * vec4(position, 1.0);

    // Centralize the spin in the galaxy center
    vec3 galaxyCenter = vec3(-1.77, -128.98, -90.82); 
    vec3 offsetFromCenter = modelPosition.xyz - galaxyCenter;

    // Spin
    float angle = atan(offsetFromCenter.x, offsetFromCenter.z);
    float distanceToCenter = length(offsetFromCenter.xz);
    float angleOffset = (1.0 / distanceToCenter) * uTime * -0.9;
    angle += angleOffset;

    modelPosition.x = galaxyCenter.x + cos(angle) * distanceToCenter;
    modelPosition.z = galaxyCenter.z + sin(angle) * distanceToCenter;


    // Randomness
    modelPosition.xyz += aRandomness;
    
    // modelPosition.x += aRandomness.x;
    // modelPosition.y += aRandomness.y;
    // modelPosition.z += aRandomness.z;


    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;
    gl_Position = projectedPosition;



    /**
     * Size
     */
    gl_PointSize = uSize * aScale;
    gl_PointSize *= (1.0 / -viewPosition.z);

    /**
     * Color
     */
    vColor = color;
}
